import { isUnlinkedAlert } from '../../../appointments/v2/utils/insuranceAlerts';

const MISSING_CODES = ['request_missing', 'authorization_missing'];

/**
 * Ação de cada aviso no card e no "Resolver" do Início, para a recepção resolver
 * sem abrir um atendimento por vez na agenda:
 *   falta vincular / não registrado / guia de outra operadora → "Vincular documento" (que também cria pedido e guia);
 *   guia aguardando → formulário da guia já em "Autorizada" (senha e validade à mão);
 *   outros problemas da guia vinculada → formulário da guia.
 * Carteirinha não tem ação aqui: o remédio é "Solicitar ao paciente".
 * O clique não sobe até a linha do card (que abre o "Resolver").
 */
export function pendingAlertAction({ onLink, onGuide }) {
  const stop = (fn) => (event) => {
    if (event) event.stopPropagation();
    fn();
  };
  return (alert) => {
    // Guia de outra operadora: vincular a da operadora certa (ou cadastrá-la)
    if (isUnlinkedAlert(alert) || alert.code === 'authorization_other_provider') {
      return { label: 'Vincular', onClick: stop(onLink) };
    }
    if (MISSING_CODES.includes(alert.code)) return { label: 'Registrar', onClick: stop(onLink) };
    if (alert.document_id) {
      return alert.code === 'authorization_pending'
        ? { label: 'Marcar autorizada', onClick: stop(() => onGuide(alert, 'authorized')) }
        : { label: 'Atualizar guia', onClick: stop(() => onGuide(alert, null)) };
    }
    return null;
  };
}
